export default __webpack_public_path__ + "static/media/partnerMKDLogo.88bb8333.svg";